
 import 'variant-guard';
 
 (function () {
    function openKlaviyoForm(id) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id]);
    }

    // Delegovaný listener funguje aj pre dynamicky vložené tlačidlá
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-klaviyo-open');
      if (!btn) return;
      e.preventDefault();

      var formId = btn.getAttribute('data-kl-form-id');
      if (!formId) return;

      openKlaviyoForm(formId);
    });
})();
  


// Swipovanie produktu image (mobile) v collection - ENABLED
// Na touch zariadeniach swipom prepíname medzi 1. a 2. fotkou + aktualizujeme pager čiarky.
document.addEventListener('DOMContentLoaded', () => {
  const isTouchDevice =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;

  if (!isTouchDevice) {
    return;
  }

  // Swipe na dotykových zariadeniach (mobile): prepínanie 1./2. fotky + pager čiarky
  const SWIPE_THRESHOLD = 40; // px
  let activeSwipe = null;

  function setActive(card, isSecondary) {
    const primaryImg = card.querySelector('.product-card__image--primary');
    const secondaryImg = card.querySelector('.product-card__image--secondary');
    const pagerPrimary = card.querySelector('.product-card__pager-item--primary');
    const pagerSecondary = card.querySelector('.product-card__pager-item--secondary');

    if (!primaryImg || !secondaryImg) return;

    if (isSecondary) {
      card.classList.add('product-card--show-secondary');
      if (pagerPrimary) pagerPrimary.classList.remove('is-active');
      if (pagerSecondary) pagerSecondary.classList.add('is-active');
    } else {
      card.classList.remove('product-card--show-secondary');
      if (pagerPrimary) pagerPrimary.classList.add('is-active');
      if (pagerSecondary) pagerSecondary.classList.remove('is-active');
    }
  }

  // TOUCH START – event delegation
  document.addEventListener(
    'touchstart',
    (e) => {
      const touch = e.touches[0];
      const mediaEl = e.target.closest('.product-card__media[data-swipe-gallery="true"]');
      if (!mediaEl) {
        activeSwipe = null;
        return;
      }

      // Ak je karta v scroll-carousel, swipovanie vypneme
      if (mediaEl.closest('scroll-carousel')) {
        activeSwipe = null;
        return;
      }

      const card = mediaEl.closest('.product-card');
      if (!card) {
        activeSwipe = null;
        return;
      }

      // ❌ UŽ NERESSETUJEME NA PRVÚ FOTKU
      // setActive(card, false);

      activeSwipe = {
        card,
        startX: touch.clientX,
        startY: touch.clientY,
        moved: false,
      };
    },
    { passive: true }
  );

  // TOUCH MOVE
  document.addEventListener(
    'touchmove',
    (e) => {
      if (!activeSwipe) return;

      const touch = e.touches[0];
      const dx = touch.clientX - activeSwipe.startX;
      const dy = touch.clientY - activeSwipe.startY;

      // vertikálny pohyb = scroll
      if (Math.abs(dy) > Math.abs(dx)) return;

      if (Math.abs(dx) > SWIPE_THRESHOLD) {
        activeSwipe.moved = true;
        e.preventDefault();
      }
    },
    { passive: false }
  );

  // TOUCH END
  document.addEventListener('touchend', (e) => {
    if (!activeSwipe) return;

    const touch = e.changedTouches[0];
    const dx = touch.clientX - activeSwipe.startX;
    const dy = touch.clientY - activeSwipe.startY;

    const card = activeSwipe.card;
    const moved = activeSwipe.moved;
    activeSwipe = null;

    // vertikálne = scroll
    if (Math.abs(dy) > Math.abs(dx)) {
      return;
    }

    // krátky pohyb = klik
    if (!moved || Math.abs(dx) < SWIPE_THRESHOLD) {
      return;
    }

    // 👉 pri každom validnom swipe len toggluj stav
    const isCurrentlySecondary = card.classList.contains('product-card--show-secondary');
    setActive(card, !isCurrentlySecondary);

    e.preventDefault();
  });
});




/**
 * ARTRA — Prestige Product Gallery Infinite Carousel (safe)
 * - true infinite (sentinel clones)
 * - arrows wrap with smooth animation
 * - thumbnails click by data-media-id (fixes wrong slide after wrap)
 * - keeps aria-current correct for your brightness CSS
 *
 * Enable:
 * - add data-infinite="true" to the MAIN <scroll-carousel id="...">
 */

// (function () {
//   // ---------- helpers ----------
//   function tagNameIs(node, name) {
//     return node && node.tagName && node.tagName.toLowerCase() === name;
//   }

//   function findInComposedPath(e, tag) {
//     const path = e.composedPath ? e.composedPath() : [];
//     return path.find((n) => tagNameIs(n, tag)) || null;
//   }

//   function getCarouselFromControls(host) {
//     const id = host?.getAttribute?.("aria-controls");
//     if (!id) return null;

//     const controlled = document.getElementById(id);
//     if (!controlled) return null;

//     if (tagNameIs(controlled, "scroll-carousel")) return controlled;
//     return controlled.querySelector?.("scroll-carousel") || null;
//   }

//   function getRealCells(carousel) {
//     const all = carousel.allCells || Array.from(carousel.children || []);
//     return all.filter(
//       (el) =>
//         el &&
//         el.nodeType === 1 &&
//         !el.hasAttribute("hidden") &&
//         !el.hasAttribute("data-infinite-clone")
//     );
//   }

//   function getAllVisibleCellsIncludingClones(carousel) {
//     return carousel.cells || [];
//   }

//   function rebuildClones(carousel) {
//     // remove old clones
//     Array.from(carousel.querySelectorAll("[data-infinite-clone]")).forEach((n) => n.remove());

//     const realCells = getRealCells(carousel);
//     if (realCells.length <= 1) return false;

//     const first = realCells[0];
//     const last = realCells[realCells.length - 1];

//     const firstClone = first.cloneNode(true);
//     const lastClone = last.cloneNode(true);

//     firstClone.setAttribute("data-infinite-clone", "first");
//     lastClone.setAttribute("data-infinite-clone", "last");

//     // [lastClone, ...real, firstClone]
//     carousel.insertBefore(lastClone, carousel.firstChild);
//     carousel.appendChild(firstClone);

//     return true;
//   }

//   // ---------- keep thumbnails/dots active correct ----------
//   function syncNavigationActiveState(carousel) {
//     const id = carousel.id;
//     if (!id) return;

//     const cells = getAllVisibleCellsIncludingClones(carousel);
//     if (!cells.length) return;

//     const idx = typeof carousel.selectedIndex === "number" ? carousel.selectedIndex : 0;

//     // normalize "selected cell" to a REAL cell (not clone)
//     let cell = carousel.selectedCell;
//     if (idx === 0) cell = cells[cells.length - 2];       // real last
//     else if (idx === cells.length - 1) cell = cells[1];  // real first

//     const mediaId = cell?.getAttribute?.("data-media-id");
//     if (!mediaId) return;

//     const navs = document.querySelectorAll(`[aria-controls="${CSS.escape(id)}"]`);

//     navs.forEach((nav) => {
//       const buttons = Array.from(nav.querySelectorAll('button[aria-current]'));
//       const hasMediaId = buttons.some((b) => b.hasAttribute("data-media-id"));

//       if (hasMediaId) {
//         buttons.forEach((b) => b.setAttribute("aria-current", "false"));
//         const match = buttons.find((b) => b.getAttribute("data-media-id") === mediaId);
//         if (match) match.setAttribute("aria-current", "true");
//       } else {
//         // dots: map by real index (exclude clones)
//         const realCount = getRealCells(carousel).length;
//         if (realCount <= 1) return;

//         let realIndex = idx - 1;
//         if (idx === 0) realIndex = realCount - 1;
//         if (idx === cells.length - 1) realIndex = 0;

//         buttons.forEach((b, i) => b.setAttribute("aria-current", i === realIndex ? "true" : "false"));
//       }
//     });
//   }

//   // ---------- select real slide by mediaId ----------
//   function selectRealSlideByMediaId(carousel, mediaId, { instant = true } = {}) {
//     const cells = getAllVisibleCellsIncludingClones(carousel);
//     const target = cells.find(
//       (c) =>
//         c &&
//         !c.hasAttribute("hidden") &&
//         !c.hasAttribute("data-infinite-clone") &&
//         c.getAttribute("data-media-id") === mediaId
//     );

//     if (!target) return false;

//     const idx = cells.indexOf(target);
//     if (idx < 0) return false;

//     const raw = carousel.__artraRawSelect || carousel.select.bind(carousel);
//     raw(idx, { instant });
//     requestAnimationFrame(() => syncNavigationActiveState(carousel));
//     return true;
//   }

//   // ---------- main init ----------
//   function ensureInfinite(carousel) {
//     if (!carousel || carousel.__artraInfiniteReady) return;
//     if (carousel.getAttribute("data-infinite") !== "true") return;
//     if (carousel.tagName?.toLowerCase() !== "scroll-carousel") return;
//     if (typeof carousel.select !== "function") return;

//     // Build clones
//     const ok = rebuildClones(carousel);
//     if (!ok) return;

//     // Save raw select (never modified)
//     if (!carousel.__artraRawSelect) {
//       carousel.__artraRawSelect = carousel.select.bind(carousel);
//     }

//     const rawSelect = (idx, opts) => carousel.__artraRawSelect(idx, opts);

//     carousel.__artraInfiniteReady = true;

//     // Fix starting position if it lands on clone after refresh
//     requestAnimationFrame(() => {
//       const cells = getAllVisibleCellsIncludingClones(carousel);
//       const idx = typeof carousel.selectedIndex === "number" ? carousel.selectedIndex : 0;
//       if (!cells.length) return;

//       if (idx === 0) rawSelect(1, { instant: true });
//       else if (idx === cells.length - 1) rawSelect(cells.length - 2, { instant: true });

//       requestAnimationFrame(() => syncNavigationActiveState(carousel));
//     });

//     // Teleport after settle if we are on clone (invisible)
//     carousel.addEventListener("carousel:settle", () => {
//       const cells = getAllVisibleCellsIncludingClones(carousel);
//       if (cells.length <= 1) return;

//       const idx = typeof carousel.selectedIndex === "number" ? carousel.selectedIndex : 0;

//       if (idx === 0) rawSelect(cells.length - 2, { instant: true }); // real last
//       else if (idx === cells.length - 1) rawSelect(1, { instant: true }); // real first

//       requestAnimationFrame(() => syncNavigationActiveState(carousel));
//     });

//     // Keep aria-current synced as user scrolls
//     carousel.addEventListener("carousel:change", () => {
//       requestAnimationFrame(() => syncNavigationActiveState(carousel));
//     });

//     // ----- arrows wrap (smooth) -----
//     if (!carousel.__artraInfiniteArrowsBound) {
//       carousel.__artraInfiniteArrowsBound = true;

//       document.addEventListener(
//         "pointerdown",
//         (e) => {
//           const prevHost = findInComposedPath(e, "carousel-prev-button");
//           const nextHost = findInComposedPath(e, "carousel-next-button");
//           if (!prevHost && !nextHost) return;

//           const host = prevHost || nextHost;
//           const controlled = getCarouselFromControls(host);
//           if (controlled !== carousel) return;

//           const cells = getAllVisibleCellsIncludingClones(carousel);
//           if (cells.length <= 1) return;

//           const idx = typeof carousel.selectedIndex === "number" ? carousel.selectedIndex : 0;

//           // real last (cells.length-2) + NEXT -> firstClone (cells.length-1)
//           if (nextHost && idx === cells.length - 2) {
//             e.preventDefault();
//             e.stopImmediatePropagation();
//             rawSelect(cells.length - 1, { instant: false });
//             return;
//           }

//           // real first (1) + PREV -> lastClone (0)
//           if (prevHost && idx === 1) {
//             e.preventDefault();
//             e.stopImmediatePropagation();
//             rawSelect(0, { instant: false });
//           }
//         },
//         true
//       );
//     }

//     // ----- thumbnails click fix (by media-id) + block theme click -----
//     if (!carousel.__artraInfiniteThumbsBound) {
//       carousel.__artraInfiniteThumbsBound = true;

//       let blockNextThumbClick = false;

//       function findThumbButtonFromEvent(e) {
//         const path = e.composedPath ? e.composedPath() : [];
//         for (const n of path) {
//           if (n && n.nodeType === 1 && n.matches?.("button.product-gallery__thumbnail")) return n;
//         }
//         return e.target.closest?.("button.product-gallery__thumbnail") || null;
//       }

//       function isThumbForThisCarousel(btn) {
//         if (!btn) return false;
//         const nav = btn.closest?.(`product-gallery-navigation[aria-controls="${CSS.escape(carousel.id)}"]`);
//         return !!nav;
//       }

//       // pointerdown capture: select correct slide by media-id
//       document.addEventListener(
//         "pointerdown",
//         (e) => {
//           const btn = findThumbButtonFromEvent(e);
//           if (!btn || !isThumbForThisCarousel(btn)) return;

//           const mediaId = btn.getAttribute("data-media-id");
//           if (!mediaId) return;

//           e.preventDefault();
//           e.stopImmediatePropagation();

//           const ok = selectRealSlideByMediaId(carousel, mediaId, { instant: true });
//           if (ok) {
//             blockNextThumbClick = true;
//             setTimeout(() => (blockNextThumbClick = false), 300);
//           }
//         },
//         true
//       );

//       // click capture: block theme's click that would re-select by index
//       document.addEventListener(
//         "click",
//         (e) => {
//           if (!blockNextThumbClick) return;

//           const btn = findThumbButtonFromEvent(e);
//           if (!btn || !isThumbForThisCarousel(btn)) return;

//           e.preventDefault();
//           e.stopImmediatePropagation();
//           blockNextThumbClick = false;
//         },
//         true
//       );
//     }

//     // Re-init if DOM changes (variant filtering / rerender)
//     const mo = new MutationObserver(() => {
//       carousel.__artraInfiniteReady = false;
//       ensureInfinite(carousel);
//     });
//     mo.observe(carousel, { childList: true, subtree: false });
//     carousel.__artraInfiniteMO = mo;
//   }

//   function boot() {
//     document.querySelectorAll('scroll-carousel[data-infinite="true"]').forEach(ensureInfinite);
//   }

//   if (window.customElements?.whenDefined) {
//     customElements.whenDefined("scroll-carousel").then(() => {
//       if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
//       else boot();

//       document.addEventListener("shopify:section:load", boot);
//       document.addEventListener("variant:change", boot);
//     });
//   } else {
//     document.addEventListener("DOMContentLoaded", boot);
//   }
// })();

/**
 * ARTRA — looping (infinite) šípky pre product gallery
 *
 * Vlastné šípky v .product-gallery-nav-buttons (snippets/product-gallery.liquid)
 * už nie sú <carousel-prev-button>/<carousel-next-button>, takže sa na krajoch
 * nedisablujú.
 *
 * Na okraji sa dočasne vloží klon cieľovej fotky hneď za (resp. pred) aktuálnu,
 * plynulo sa naň odscrolluje — takže prechod vyzerá presne ako bežný krok — a po
 * dobehnutí animácie sa klon odstráni a carousel sa nastaví na reálnu fotku.
 *
 * Aby theme klon nepovažoval za ďalší slajd (a nerozhodili sa indexy thumbnailov),
 * carouselu nastavíme cell-selector, ktorý klony vynecháva.
 */
(function () {
  const CLONE_ATTR = 'data-loop-clone';
  const CELL_SELECTOR = `:scope > :not([${CLONE_ATTR}])`;
  const ANIMATION_FALLBACK = 800; // poistka, keby scrollend nedorazil

  const busy = new WeakSet();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function useCloneAwareCells(carousel) {
    if (carousel.getAttribute('cell-selector') === CELL_SELECTOR) return true;

    try {
      carousel.querySelector(':scope > *');
    } catch (error) {
      return false; // prehliadač nepozná :scope — pôjde sa fallbackom bez klonu
    }

    carousel.setAttribute('cell-selector', CELL_SELECTOR);
    return true;
  }

  // Rovnaký výpočet, aký používa scroll-carousel v theme.js pre zarovnanie bunky
  function alignedScrollLeft(carousel, cell) {
    const styles = getComputedStyle(carousel);
    const isLtr = document.dir !== 'rtl';
    let scrollLeft;

    switch (carousel.cellAlign) {
      case 'start':
        scrollLeft = isLtr
          ? cell.offsetLeft - (parseInt(styles.scrollPaddingInlineStart) || 0)
          : cell.offsetLeft + cell.offsetWidth - carousel.clientWidth + (parseInt(styles.scrollPaddingInlineStart) || 0);
        break;
      case 'end':
        scrollLeft = isLtr
          ? cell.offsetLeft + cell.offsetWidth - carousel.clientWidth + (parseInt(styles.scrollPaddingInlineEnd) || 0)
          : cell.offsetLeft - (parseInt(styles.scrollPaddingInlineEnd) || 0);
        break;
      default:
        scrollLeft = Math.round(cell.offsetLeft - carousel.clientWidth / 2 + cell.clientWidth / 2);
    }

    return isLtr
      ? Math.min(Math.max(scrollLeft, 0), carousel.scrollWidth - carousel.clientWidth)
      : Math.min(Math.max(scrollLeft, carousel.clientWidth - carousel.scrollWidth), 0);
  }

  function eagerLoadImages(cell) {
    cell?.querySelectorAll('img[loading="lazy"]').forEach((img) => img.removeAttribute('loading'));
  }

  // Klon slúži len ako statická medzifáza animácie — bez id, bez prehrávateľných médií
  function createGhost(cell) {
    const isImage = (cell.getAttribute('data-media-type') || 'image') === 'image';
    let ghost;

    if (isImage) {
      ghost = cell.cloneNode(true);
    } else {
      // Pri videu/3D preberáme len náhľadový obrázok, nech sa custom elementy nespúšťajú nanovo
      const preview = cell.querySelector('img');
      if (!preview) return null;

      ghost = cell.cloneNode(false);
      ghost.appendChild(preview.cloneNode(true));
    }

    ghost.setAttribute(CLONE_ATTR, '');
    ghost.setAttribute('aria-hidden', 'true');
    ghost.removeAttribute('id');
    ghost.removeAttribute('data-media-id');
    ghost.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
    ghost.querySelectorAll('video, model-viewer, iframe, script, template').forEach((node) => node.remove());
    eagerLoadImages(ghost);
    ghost.style.pointerEvents = 'none';

    return ghost;
  }

  function loopTo(carousel, direction) {
    const cells = carousel.cells;
    const targetIndex = direction === 'next' ? 0 : cells.length - 1;
    const anchor = cells[carousel.selectedIndex];
    const targetCell = cells[targetIndex];

    if (!anchor || !targetCell) return false;

    const ghost = createGhost(targetCell);
    if (!ghost) return false;

    busy.add(carousel);

    const scrollBefore = carousel.scrollLeft;
    const anchorBefore = anchor.offsetLeft;

    if (direction === 'next') {
      carousel.appendChild(ghost);
    } else {
      carousel.insertBefore(ghost, carousel.firstElementChild);
    }

    // Vloženie na začiatok posunie celý obsah — dorovnáme scroll, nech to vizuálne nepodskočí
    const shift = anchor.offsetLeft - anchorBefore;
    if (shift !== 0) {
      const previousBehavior = carousel.style.scrollBehavior;
      carousel.style.scrollBehavior = 'auto';
      carousel.scrollLeft = scrollBefore + shift;
      carousel.style.scrollBehavior = previousBehavior;
    }

    // Thumbnaily nech skočia hneď, rovnako ako pri bežnom kliku
    carousel.dispatchEvent(new CustomEvent('carousel:change', { detail: { index: targetIndex, cell: targetCell } }));

    const goal = alignedScrollLeft(carousel, ghost);

    carousel.scrollTo({ left: goal, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });

    let timer;

    const finish = () => {
      clearTimeout(timer);
      carousel.removeEventListener('scrollend', onScrollEnd);
      ghost.remove();
      carousel.select(targetIndex, { instant: true });
      busy.delete(carousel);
    };

    // Klon vymeníme za reálnu fotku až keď animácia naozaj dobehla na jeho pozíciu
    const onScrollEnd = () => {
      if (Math.abs(carousel.scrollLeft - goal) > 4) return;
      finish();
    };

    carousel.addEventListener('scrollend', onScrollEnd);
    timer = setTimeout(finish, ANIMATION_FALLBACK);

    return true;
  }

  document.addEventListener('click', (event) => {
    const nav = event.target.closest?.('[data-gallery-loop-nav]');
    if (!nav) return;

    const carousel = document.getElementById(nav.getAttribute('data-carousel'));
    if (!carousel || typeof carousel.select !== 'function' || busy.has(carousel)) return;

    const total = carousel.cells.length;
    if (total < 2) return;

    const direction = nav.getAttribute('data-gallery-loop-nav') === 'next' ? 'next' : 'prev';
    const current = carousel.selectedIndex;
    const atEdge = direction === 'next' ? current >= total - 1 : current <= 0;

    if (!atEdge) {
      carousel.select(current + (direction === 'next' ? 1 : -1));
      return;
    }

    const looped = useCloneAwareCells(carousel) && loopTo(carousel, direction);

    if (!looped) {
      carousel.select(direction === 'next' ? 0 : total - 1, { instant: true });
    }
  });

  // Krajné fotky načítame vopred, aby klon pri prechode nebol prázdny
  function primeEdges() {
    document.querySelectorAll('[data-gallery-loop-nav][data-carousel]').forEach((nav) => {
      const carousel = document.getElementById(nav.getAttribute('data-carousel'));
      const cells = carousel?.cells;
      if (!cells?.length) return;

      eagerLoadImages(cells[0]);
      eagerLoadImages(cells[cells.length - 1]);
    });
  }

  if (window.customElements?.whenDefined) {
    customElements.whenDefined('scroll-carousel').then(() => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', primeEdges);
      } else {
        primeEdges();
      }

      document.addEventListener('shopify:section:load', primeEdges);
      document.addEventListener('variant:change', primeEdges);
    });
  }
})();

// ========================================
// Posuvník pod karuselom produktov (desktop) – <carousel-scrollbar aria-controls="ID">
// Palec kopíruje scroll karuselu, dá sa ťahať myšou a klik na dráhu ho presunie pod kurzor.
// Po pustení sa karusel dorovná na najbližšiu kartu (rovnako ako drag v theme.js) a až potom
// sa znova zapne scroll-snap – keby sa zapol skôr, prehliadač by skočil na snap pozíciu.
// Markup: snippets/carousel-scrollbar.liquid, CSS: assets/custom.css.
// ========================================
(function () {
  if (!window.customElements || window.customElements.get('carousel-scrollbar')) return;

  const CAROUSEL_DRAGGING_CLASS = 'is-scrollbar-dragging';
  const MIN_THUMB_WIDTH = 32;
  const SETTLE_FALLBACK = 1000;
  const pointerFine = window.matchMedia('screen and (pointer: fine)');

  function isLtr() {
    return document.dir !== 'rtl';
  }

  // Rovnaký výpočet, aký používa scroll-carousel v theme.js pre zarovnanie bunky
  function alignedScrollLeft(carousel, cell) {
    const styles = getComputedStyle(carousel);
    const ltr = isLtr();
    let scrollLeft;

    switch (carousel.cellAlign) {
      case 'start':
        scrollLeft = ltr
          ? cell.offsetLeft - (parseInt(styles.scrollPaddingInlineStart) || 0)
          : cell.offsetLeft + cell.offsetWidth - carousel.clientWidth + (parseInt(styles.scrollPaddingInlineStart) || 0);
        break;
      case 'end':
        scrollLeft = ltr
          ? cell.offsetLeft + cell.offsetWidth - carousel.clientWidth + (parseInt(styles.scrollPaddingInlineEnd) || 0)
          : cell.offsetLeft - (parseInt(styles.scrollPaddingInlineEnd) || 0);
        break;
      default:
        scrollLeft = Math.round(cell.offsetLeft - carousel.clientWidth / 2 + cell.clientWidth / 2);
    }

    return ltr
      ? Math.min(Math.max(scrollLeft, 0), carousel.scrollWidth - carousel.clientWidth)
      : Math.min(Math.max(scrollLeft, carousel.clientWidth - carousel.scrollWidth), 0);
  }

  // Bunka najbližšie k hrane zarovnania – kópia calculateClosestIndexToAlignment zo scroll-carousel
  function closestCellIndex(carousel) {
    const cells = carousel.cells;
    const align = carousel.cellAlign;
    const alignsToStart = (align === 'start' && isLtr()) || (align === 'end' && !isLtr());
    let points;
    let target;

    if (align === 'center') {
      points = cells.map((cell) => Math.round(cell.offsetLeft + cell.clientWidth / 2));
      target = Math.round(carousel.scrollLeft + carousel.clientWidth / 2);
    } else if (alignsToStart) {
      points = cells.map((cell) => cell.offsetLeft);
      target = carousel.scrollLeft;
    } else {
      points = cells.map((cell) => cell.offsetLeft + cell.clientWidth);
      target = carousel.scrollLeft + carousel.clientWidth;
    }

    let closest = 0;

    points.forEach((point, index) => {
      if (Math.abs(point - target) < Math.abs(points[closest] - target)) closest = index;
    });

    return closest;
  }

  class CarouselScrollbar extends HTMLElement {
    constructor() {
      super();
      this.update = this.update.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.drag = null;
      this.cancelSettle = null;
    }

    connectedCallback() {
      this.carousel = document.getElementById(this.getAttribute('aria-controls') || '');
      this.track = this.querySelector('.carousel-scrollbar__track');
      this.thumb = this.querySelector('.carousel-scrollbar__thumb');

      if (!this.carousel || !this.track || !this.thumb) return;

      this.carousel.addEventListener('scroll', this.update, { passive: true });
      this.addEventListener('pointerdown', this.onPointerDown);
      pointerFine.addEventListener('change', this.update);

      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.carousel);

      this.update();
    }

    disconnectedCallback() {
      this.carousel?.removeEventListener('scroll', this.update);
      pointerFine.removeEventListener('change', this.update);
      this.resizeObserver?.disconnect();
      this.stopDrag();
      this.cancelSettle?.();
    }

    get metrics() {
      const { scrollWidth, clientWidth, scrollLeft } = this.carousel;
      const maxScroll = Math.max(scrollWidth - clientWidth, 0);
      const trackWidth = this.track.clientWidth;
      const thumbWidth = maxScroll > 0
        ? Math.min(trackWidth, Math.max(Math.round((trackWidth * clientWidth) / scrollWidth), MIN_THUMB_WIDTH))
        : trackWidth;

      return {
        maxScroll,
        trackWidth,
        thumbWidth,
        progress: maxScroll > 0 ? Math.min(Math.abs(scrollLeft) / maxScroll, 1) : 0,
      };
    }

    update() {
      if (!this.carousel || !pointerFine.matches) return;

      // Najprv odkryť, až potom merať – schovaná dráha má nulovú šírku
      const scrollable = this.carousel.scrollWidth - this.carousel.clientWidth > 1;
      this.toggleAttribute('hidden', !scrollable);
      if (!scrollable) return;

      const { trackWidth, thumbWidth, progress } = this.metrics;
      const offset = (isLtr() ? 1 : -1) * progress * (trackWidth - thumbWidth);

      this.thumb.style.width = `${thumbWidth}px`;
      this.thumb.style.transform = `translateX(${offset}px)`;
    }

    onPointerDown(event) {
      if (event.button !== 0 || this.hidden || this.drag) return;

      const { maxScroll, trackWidth, thumbWidth } = this.metrics;
      if (maxScroll <= 0 || trackWidth <= thumbWidth) return;

      event.preventDefault();

      const ltr = isLtr();
      const trackRect = this.track.getBoundingClientRect();
      const thumbRect = this.thumb.getBoundingClientRect();
      const onThumb = this.thumb.contains(event.target);
      // Vzdialenosť kurzora od začiatočnej hrany palca; pri kliku na dráhu skočí palec stredom pod kurzor
      const grabOffset = onThumb
        ? (ltr ? event.clientX - thumbRect.left : thumbRect.right - event.clientX)
        : thumbWidth / 2;

      this.drag = {
        pointerId: event.pointerId,
        ltr,
        trackStart: ltr ? trackRect.left : trackRect.right,
        range: trackWidth - thumbWidth,
        maxScroll,
        grabOffset,
      };

      // Prebiehajúce dorovnávanie z predchádzajúceho ťahania zrušiť (drag je už nastavený, snap ostane vypnutý)
      this.cancelSettle?.();

      this.classList.add('is-dragging');
      this.carousel.classList.add(CAROUSEL_DRAGGING_CLASS);
      this.setPointerCapture(event.pointerId);
      this.addEventListener('pointermove', this.onPointerMove);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerUp);

      if (!onThumb) this.onPointerMove(event);
    }

    onPointerMove(event) {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;

      const { ltr, trackStart, range, maxScroll, grabOffset } = this.drag;
      const distance = (ltr ? event.clientX - trackStart : trackStart - event.clientX) - grabOffset;
      const progress = Math.min(Math.max(distance / range, 0), 1);

      this.carousel.scrollLeft = (ltr ? 1 : -1) * progress * maxScroll;
    }

    onPointerUp(event) {
      if (!this.drag || event.pointerId !== this.drag.pointerId) return;

      this.stopDrag();
      this.settle();
    }

    stopDrag() {
      if (!this.drag) return;

      const { pointerId } = this.drag;

      this.removeEventListener('pointermove', this.onPointerMove);
      this.removeEventListener('pointerup', this.onPointerUp);
      this.removeEventListener('pointercancel', this.onPointerUp);
      if (this.hasPointerCapture(pointerId)) this.releasePointerCapture(pointerId);

      this.drag = null;
      this.classList.remove('is-dragging');
    }

    // Po pustení palca dorovnať karusel na najbližšiu kartu a až potom vrátiť scroll-snap
    settle() {
      const carousel = this.carousel;
      const cells = carousel.cells;
      const enableSnap = () => carousel.classList.remove(CAROUSEL_DRAGGING_CLASS);

      // theme.js ešte nebeží – nie je podľa čoho zarovnávať
      if (!cells?.length || typeof carousel.select !== 'function') {
        enableSnap();
        return;
      }

      const index = closestCellIndex(carousel);
      const goal = alignedScrollLeft(carousel, cells[index]);

      if (Math.abs(carousel.scrollLeft - goal) <= 1) {
        enableSnap();
        return;
      }

      let timer;

      const finish = () => {
        clearTimeout(timer);
        carousel.removeEventListener('scrollend', onScrollEnd);
        this.cancelSettle = null;
        // Ak medzitým začal nový drag, snap vráti až jeho settle()
        if (!this.drag) enableSnap();
      };

      // Snap zapnúť až keď animácia naozaj dobehla na cieľ (scrollend z ťahania ignorovať)
      const onScrollEnd = () => {
        if (Math.abs(carousel.scrollLeft - goal) > 4) return;
        finish();
      };

      this.cancelSettle = finish;
      carousel.addEventListener('scrollend', onScrollEnd);
      timer = setTimeout(finish, SETTLE_FALLBACK);
      carousel.select(index);
    }
  }

  window.customElements.define('carousel-scrollbar', CarouselScrollbar);
})();
